import React, { useState, useEffect } from 'react';
import { get_skin_diary_only_added } from "../Services/Service";
import { Modal, Button } from "react-bootstrap";
import ImagesGalleryView from '../WebPages/ImagesGalleryView'

function SkinDiary({ uuid }) {
    console.log(uuid, "uuid")
    const [skinMasterId, setSkinMasterId] = useState('');
    const [skinName, setSkinName] = useState('');
    const [skinCount, setSkinCount] = useState('');
    const [userId, setUserId] = useState(uuid);
    const [showImagePopUpModal, setshowImagePopUpModal] = useState(false);
    const [skinResponse, setSkinResponse] = useState([]);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    console.log(showImagePopUpModal, "showImagePopUpModal")
    console.log("updated")


    useEffect(() => {
        const fetchData = async () => {
            try {
                const skinDiaryResponse = await get_skin_diary_only_added({ uuid: uuid });
                setSkinResponse(skinDiaryResponse.data.data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, []);


    const handleImage = (e) => {
        setshowImagePopUpModal(true);
    };



    const handleClosePopup = (event) => {
        setshowImagePopUpModal(false)
    }

    const openImagesGalleryView = (event) => {
        const skinId = event.currentTarget.getAttribute('attr-id');
        setSkinMasterId(skinId);
        const skinName = event.currentTarget.getAttribute('attr-name');
        setSkinName(skinName);
        const skinCount = event.currentTarget.getAttribute('attr-imgcount');
        setSkinCount(skinCount);
    }


    return (
        // <>
        //     <div className='row'>

        //         <>

        //             <div className='col-6 col-md-6 mt-4 border-start px-5' >
        //                 <div className='row align-items-center' style={{ cursor: "pointer" }}>
        //                     <div className='col-auto'>
        //                         <img src="https://appcdn.goqii.com/storeimg/19248_1712147640.png" alt="person" class="person-img" />
        //                     </div>
        //                     <div className='col ps-0'>
        //                         <p class="person-subtitle mb-0">Head &amp; Neck (7 images)</p>
        //                     </div>
        //                 </div>
        //             </div>

        //             <div className='col-6 col-md-6 mt-4 border-start px-5' >
        //                 <div className='row align-items-center' style={{ cursor: "pointer" }}>
        //                     <div className='col-auto'>
        //                         <img src="https://appcdn.goqii.com/storeimg/19248_1712147640.png" alt="person" class="person-img" />
        //                     </div>
        //                     <div className='col ps-0'>
        //                         <p class="person-subtitle mb-0">Head &amp; Neck (7 images)</p>
        //                     </div>
        //                 </div>
        //             </div>

        //         </>

        //     </div>
        // </>
        <>

            <div className='row'>
                {skinResponse && skinResponse.map((record) => (
                    <>

                        <div className='col-md-3 mt-4 px-5' attr-name={record.recordName} attr-id={record.recordType} attr-imgcount={record.recordImgCount} onClick={(e) => { openImagesGalleryView(e) }} >
                            <div className='row align-items-center' onClick={(e) => { handleShow(e) }} style={{ cursor: "pointer" }}>
                                {/* <div className='row align-items-center' data-bs-toggle="modal" data-bs-target="#exampleModal"> */}
                                <div className='col-auto'>
                                    <img src={record.recordImg} alt="person" className='person-img' />
                                </div>
                                <div className='col'>
                                    {record.recordImgCount > 0 ?
                                        <p className='person-subtitle mb-0'>{record.recordName} ({record.recordImgCount} images)</p> :
                                        <p className='person-subtitle mb-0'>{record.recordName} (NO images)</p>}
                                </div>
                            </div>
                        </div>
                    </>
                ))}

            </div>
            {/* {showImagePopUpModal && ( */}
            <div className="modal show">
                <Modal.Dialog className='modal-dialog modal-dialog-centered'>

                    <>
                        <Modal.Header closeButton onClick={handleClosePopup}>
                            <Modal.Title>{skinName}</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <div className='imageGalleryBG'>
                                {skinCount > 0 ? <ImagesGalleryView skinMasterId={skinMasterId} uuid={userId} /> : 'NO Images'}
                            </div>
                        </Modal.Body>
                    </>
                </Modal.Dialog>
            </div>
            {/* )} */}



            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton onClick={handleClosePopup}>
                    <Modal.Title>{skinName}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className='imageGalleryBG'>
                        {skinCount > 0 ? <ImagesGalleryView skinMasterId={skinMasterId} uuid={userId} /> : 'NO Images'}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default SkinDiary;
